document.addEventListener('DOMContentLoaded', function() {
  const slider = document.querySelector('.slider');
  const slides = document.querySelectorAll('.slider-item');
  let currentIndex = 0;

  function slideTo(index) {
    const maxIndex = slides.length - 1;
    if (index < 0) index = 0;
    if (index > maxIndex) index = maxIndex;

    currentIndex = index;
    slider.style.transform = `translateX(-${currentIndex * 100}%)`;
  }

  document.querySelector('.next').addEventListener('click', function() {
    slideTo(currentIndex + 1);
  });

  document.querySelector('.prev').addEventListener('click', function() {
    slideTo(currentIndex - 1);
  });
});